import React, { useRef } from 'react';
import { Editor as TinyMCEEditor } from '@tinymce/tinymce-react';

function Editor({ value, onChange, name, height = 300 }) {
  const editorRef = useRef(null);

  const handleEditorChange = (content) => {
    if (onChange) {
      // Crear un evento sintético para mantener la compatibilidad con handleChange
      const event = {
        target: {
          name: name,
          value: content
        }
      };
      onChange(event);
    }
  };

  return (
    <TinyMCEEditor
      tinymceScriptSrc="/tinymce/js/tinymce/tinymce.min.js"
      onInit={(evt, editor) => editorRef.current = editor}
      value={value || ''}
      onEditorChange={handleEditorChange}
      init={{
        height: height,
        menubar: false,
        plugins: [
          'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
          'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
          'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
        ],
        toolbar: 'undo redo | blocks | ' +
          'bold italic forecolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | ' +
          'removeformat | help',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        language: 'es',
        branding: false,
        license_key: 'gpl'
      }}
    />
  );
}

export default Editor;

